import {
  FETCH_ONDUTYTYPES_SUCCESS,
  CREATE_ONDUTYTYPE,
  UPDATE_ONDUTYTYPE,
  DELETE_ONDUTYTYPE,
  SET_ONDUTYTYPE_ID,
} from "actions/types";
import { produce } from "immer";

const initialState = {
  OnDutyTypes: [],
  onDutyTypeId: -1,
  error: "",
};

const onDutyTypesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    var key;
    switch (action.type) {
      case FETCH_ONDUTYTYPES_SUCCESS:
        draft.OnDutyTypes = action.payload;
        draft.error = "";
        break;
      case CREATE_ONDUTYTYPE:
        draft.OnDutyTypes = [action.payload, ...draft.OnDutyTypes];
        draft.error = "";
        break;
      case UPDATE_ONDUTYTYPE:
        key = draft.OnDutyTypes.findIndex(
          (CL) => CL.id === action.payload.id
        );
        draft.OnDutyTypes[key] = action.payload;
        draft.businessTripId = -1;
        draft.error = "";
        break;
      case DELETE_ONDUTYTYPE:
        key = draft.OnDutyTypes.findIndex(
          (CL) => CL.id === action.payload.id
        );
        draft.OnDutyTypes.splice(key, 1);
        draft.businessTripId = -1;
        draft.error = "";
        break;
      case SET_ONDUTYTYPE_ID:
        draft.onDutyTypeId = action.payload;
        break;
      default:
        return state;
    }
  });

export default onDutyTypesReducer;
